import type { NavigateProps } from "react-router"
import { Navigate, useLocation } from "react-router"

export function NavigateWithParams(props: NavigateProps) {
  const { search } = useLocation()

  return <Navigate {...props} to={`${props.to}${search}`} />
}
